import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';

const ListTable = ({
  loading,
  data,
  onTableChange,
  pagination,
  columns,
  rowKey,
  onSelectRows, // Callback function to send selected data to parent
  selectedRowKeys,
  showCheckbox = true, // New prop to control checkbox visibility
}) => {
  const rowSelection = {
    onChange: (_, selectedRows) => {
      if (selectedRows) {
        onSelectRows(selectedRows); // Pass selected data to the parent component
      }
    },
    getCheckboxProps: (record) => ({
      disabled: record?.isDisabled,
      // Column configuration not to be checked
      name: record.name,
    }),
  };
  const resolvedPagination =
    pagination === false
      ? false
      : pagination
        ? {
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            ...pagination,
          }
        : pagination;

  return (
    <div className="table-responsive doctor-list">
      <Table
        loading={loading}
        onChange={onTableChange}
        pagination={resolvedPagination}
        columns={columns}
        dataSource={data}
        rowKey={rowKey}
        scroll={{ x: 'max-content' }}
        tableLayout="fixed"
        rowSelection={
          showCheckbox
            ? {
              type: 'checkbox',
              selectedRowKeys,
              ...rowSelection,
            }
            : undefined
        }
      />
    </div>
  );
};

ListTable.propTypes = {
  loading: PropTypes.bool, // Refer the `ant` table for more details on this prop
  data: PropTypes.array, // Refer the `ant` table for more details on this prop
  onTableChange: PropTypes.func, // Refer the `ant` table for more details on this prop
  pagination: PropTypes.any, // Refer the `ant` table for more details on this prop
  columns: PropTypes.array, // Refer the `ant` table for more details on this prop
  rowKey: PropTypes.func,
  onSelectRows: PropTypes.func, // Prop to send selected rows
  selectedRowKeys: PropTypes.array, // Prop to send selected rows
  showCheckbox: PropTypes.bool, // Prop to control checkbox visibility
};

export default ListTable;
